export const Plus = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g id='Operations-Plus-Simple'>
      <mask
        id='mask0_199_26111'
        mask-type='alpha'
        maskUnits='userSpaceOnUse'
        x='2'
        y='2'
        width='16'
        height='16'
      >
        <path
          id='icon'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.625 3.125C10.625 2.77982 10.3452 2.5 10 2.5C9.65482 2.5 9.375 2.77982 9.375 3.125V9.375H3.125C2.77982 9.375 2.5 9.65482 2.5 10C2.5 10.3452 2.77982 10.625 3.125 10.625H9.375V16.875C9.375 17.2202 9.65482 17.5 10 17.5C10.3452 17.5 10.625 17.2202 10.625 16.875V10.625H16.875C17.2202 10.625 17.5 10.3452 17.5 10C17.5 9.65482 17.2202 9.375 16.875 9.375H10.625V3.125Z'
          fill='black'
        />
      </mask>
      <g mask='url(#mask0_199_26111)'>
        <path id='color' d='M20 0H0V20H20V0Z' fill='white' />
      </g>
    </g>
  </svg>
)
